import { IApplication } from "@rentiohq/shared-frontend/dist/types/application.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { Modal } from "@rentiohq/web-shared/dist/components";
import React from "react";
import {
  getDefaultCandidacyDeadline,
  toCandidacyDeadlinePayload,
} from "utils/candidacyDeadline.utils";
import * as S from "../VisitMode.styled";
import { getCandidateName } from "../visitMode.utils";
import { CandidacyDeadlineInput } from "./CandidacyDeadlineInput";

interface IProps {
  application: IApplication;
  onClose: () => void;
  /** The deadline as the API expects it: 'YYYY-MM-DD', or null for none. */
  onConfirm: (candidacyDeadline: string | null) => void;
}

/**
 * One candidate, so there is nothing to choose: a list with a single tick asks
 * a question that answers itself. What is worth asking is whether to send at
 * all, because the mail cannot be taken back and the button that opens this
 * sits under a note field a thumb has just been typing in.
 */
export const ConfirmInviteModal = (props: IProps) => {
  const { application, onClose, onConfirm } = props;

  const candidateName = getCandidateName(application);

  // State
  const [candidacyDeadline, setCandidacyDeadline] = React.useState<Date | null>(
    () => getDefaultCandidacyDeadline(),
  );

  return (
    <Modal
      width="small"
      heading={getLocalizedText("visit_mode.invite.confirm_single.heading")}
      hasDismiss={true}
      onClose={onClose}
      actions={[
        {
          content: getLocalizedText("system.cancel"),
          onClick: onClose,
          appearance: "outline",
        },
        {
          content: getLocalizedText("visit_mode.invite.confirm_single.action"),
          onClick: () =>
            onConfirm(toCandidacyDeadlinePayload(candidacyDeadline)),
          appearance: "primary",
        },
      ]}
    >
      <S.ConfirmBody>
        {getLocalizedText("visit_mode.invite.confirm_single.body", {
          name: candidateName,
        })}
      </S.ConfirmBody>

      <CandidacyDeadlineInput
        value={candidacyDeadline}
        onChange={setCandidacyDeadline}
      />
    </Modal>
  );
};
